<div  class="flex flex-col w-full gap-5 min-h-screen-50 items-center justify-center">
    <lottie-player  src="/assets/lottie/s-loader.json" background="transparent" speed="1"
      style="width: 17rem; height: 17rem;" loop autoplay="false"></lottie-player>
  </div>